<template>
  <div class="lifeGuardAuditDetail">
    <el-form label-width="140px" :model="dataForm">
      <el-form-item label="培训主题：">
        {{ dataForm.Title }}
      </el-form-item>
      <!-- <el-form-item label="截止报名时间：">
        {{ (dataForm.DeadLine * 1000) | formatDate }}
      </el-form-item>
      <el-form-item label="开始培训时间：">
        {{ (dataForm.StartTime * 1000) | formatDate }}
      </el-form-item>
      <el-form-item label="结束培训时间：">
        {{ (dataForm.EndTime * 1000) | formatDate }}
      </el-form-item> -->
      <el-form-item label="培训地址：">
        {{ dataForm.Address }}
      </el-form-item>
      <el-form-item label="报名条件：">
        {{ dataForm.Condition }}
      </el-form-item>
      <el-form-item label="个人费用(元)：">
        {{ dataForm.PersonalCost }}
      </el-form-item>
      <el-form-item label="团体费用(元)：">
        {{ dataForm.GroupCost }}
      </el-form-item>
      <!-- <el-form-item label="最低开班人数：">
        {{ dataForm.MinimumPeople }}
      </el-form-item>
      <el-form-item label="最高开班人数：">
        {{ dataForm.MaximumPeople }}
      </el-form-item> -->
      <el-form-item label="联系电话：">
        {{ dataForm.Phone }}
      </el-form-item>

      <el-form-item label="封面图：">
        <el-row>
            <el-col :span="20">{{headImage.FileName}}</el-col>
            <el-col :span="4">
                <el-button type="text" @click="download('/files' + headImage.StorePath)">下载</el-button>
                <el-button type="text" @click="showImageViewer">查看</el-button>
            </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="上传附件：">
          <el-row v-for="(item,index) in filesList" :key="index">
            <el-col :span="20">{{item.name}}</el-col>
            <el-col :span="4">
                <el-button type="text" @click="download('/Sys/File/Download?Id=' + item.url)">下载</el-button>
            </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="培训介绍：">
        <of-tinymce
          ref="editor"
          v-model="dataForm.Abstract"
          :height="500"
          :isEdit="true"
        ></of-tinymce>
      </el-form-item>
    </el-form>
    <imageViewer v-if="isShowImageViewe" :imageViewerUrl="imageViewerUrl" @closeImageViewer="closeImageViewer" />
  </div>
</template>
<script>
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import imageViewer from "@/components/controls/of_imageViewer";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
export default {
  name: "lifeGuardAuditDetail",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
  },
  data(){
      return{
          headImage: {},
          isShowImageViewe: false,
          imageViewerUrl: '',
          filesList: []
      }
  },
  components: {
      OfTinymce,
      imageViewer
  },
  mounted(){
      const vm = this
      vm.getHeadImge()
      vm.getFiles()
  },
  methods:{
      getFiles(){
          const vm = this
          if(vm.dataForm.File && vm.dataForm.File !== null && vm.dataForm.File !== ''){
              vm.filesList = JSON.parse(vm.dataForm.File)
          }
      },
      closeImageViewer(){
          const vm = this
          vm.isShowImageViewe = false
      },
      download(url){
          const vm = this
          saveAs(url,vm.headImage.FileName)
      },
      showImageViewer(){
          const vm = this
          vm.imageViewerUrl = '/files' + vm.headImage.StorePath
          vm.isShowImageViewe = true
      },
      getHeadImge(){
          const vm = this
          const request = {id: vm.dataForm.HeadImge}
          api.QueryBigSickApplyFileByIds(request).then(res=>{
              if(res.data.Code === 0 && res.data.Data !== null && res.data.Data.length > 0){
                  vm.headImage = res.data.Data[0]
              }
          })
      }
  }
};
</script>